import { Container, Row, Col } from "react-bootstrap";
import Pic from "../assets/img/Pic.png";
import "animate.css";
import TrackVisibility from "react-on-screen";
import colorSharp from "../assets/img/color-sharp2.png";
import React from "react";

const AnimatedSection = ({ children, animationClass, style }) => (
  <TrackVisibility>
    {({ isVisible }) => (
      <div
        className={isVisible ? `animate__animated ${animationClass}` : ""}
        style={style}
      >
        {children}
      </div>
    )}
  </TrackVisibility>
);

const About = () => {
  const aboutInfo = [
    {
      title: "Who I am?",
      description:
        "Web developer with 2 years of experience in frontend development, specializing in React.js, Redux, JavaScript, TypeScript, and modern UI frameworks. Skilled in building dynamic, responsive, and high-performance web applications that enhance user engagement. Experienced with MUI, Ant Design, Tailwind CSS, Bootstrap 5.2, React Bootstrap, Firebase Database, and various libraries like Axios, React Router, and styled-components to create seamless, feature-rich websites. Proficient in optimizing web platforms with intuitive design and seamless functionality, improving both UX and performance. Currently upskilling in UI/UX, React Native, Next.js, and DevOps to stay ahead in the evolving tech landscape. Passionate about clean code, performance optimization, and crafting impactful digital experiences. Seeking a Jr. Software Developer role at MSBC to apply my expertise, collaborate with talented teams, and contribute to cutting-edge software solutions.",
      animationClass: "animate__fadeIn",
      textStyle: {
        color: " rgb(22, 242, 179)",
        paddingBottom: "10px",
        fontWeight: 400,
      },
    },
  ];

  return (
    <section className="about" id="about">
      <Container style={{ padding: "15px" }}>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={8}>
            {aboutInfo.map((info, index) => (
              <AnimatedSection key={index} animationClass={info.animationClass}>
                <h4 style={info.textStyle}>{info.title}</h4>
                <h5>{info.description}</h5>
              </AnimatedSection>
            ))}
          </Col>
          <Col xs={12} md={6} xl={4}>
            <img
              src={Pic}
              alt="Profile"
              style={{
                borderRadius: "15px",
                borderImage: "15px",
                height: "380px",
                width: "380px",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "65.5rem",
                right: "-8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  backgroundColor: "#1a1443",
                  color: "white",
                  padding: "5px 7px",
                  fontSize: "1.50rem",
                  borderRadius: "0.375rem",
                  transform: "rotate(90deg)",
                }}
              >
                ABOUT ME
              </span>
              <span
                style={{
                  height: "9rem",
                  width: "2px",
                  backgroundColor: "#1a1443",
                }}
              ></span>
            </div>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp} alt="Image" />
      <hr />
    </section>
  );
};

export default About;
